import { city as citydel } from "ca-plateform-campaign-delivery-domain";
import { city as cityPlat } from "ca-plateform-plateform-commons";
import { rejectDeliveryTours } from "./command/rejectDeliveryTours";
import { getRejectedDeliveryTours } from "./query/getRejectedDeliveryTours";
import {queueForceAcceptDeliveryTours} from "./command/queueForceAcceptDeliveryTours";

export interface DeliveryTourPage
  extends cityPlat.colisactiv.platform.commons.Page<RejectedDeliveryTour> {}

export interface RejectedDeliveryTour
  extends citydel.colisactiv.platform.campaign.delivery.model
    .RejectedDeliveryTour {
  bonusIds: number[];
  packCountPerCarrier: Map<string, number>;
}

export const campaignDeliveryClient = {
  query: {
    getRejectedDeliveryTours: getRejectedDeliveryTours,
  },
  command: {
    rejectDeliveryTours: rejectDeliveryTours,
    queueForceAcceptDeliveryTours: queueForceAcceptDeliveryTours
  },
};
